import { MImageModule } from './m-image/m-image.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from './content.component';
import { RouterModule } from '@angular/router';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { RightMenuComponent } from './right-menu/right-menu.component';
import { BlockLinkComponent } from './block-link/block-link.component';
import { ApiService } from 'src/app/common/api-service/api.service';
import { MAboutComponent } from './m-about/m-about.component';
import { AuthGuard } from 'src/app/common/_helpers/auth.guard';

@NgModule({
    declarations: [
        ContentComponent,
        RightMenuComponent,
        BlockLinkComponent,
        MAboutComponent,
    ],
    imports: [
        TransferHttpCacheModule,
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: ContentComponent,
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('./m-home/m-home.module').then(m => m.MHomeModule)
                    },
                    {
                        path: 'list/:keyword/:title/:id',
                        loadChildren: () =>
                            import('./m-list/m-list.module').then(m => m.MListModule)
                    },
                    {
                        path: 'detail/:keyword/:title/:id/:typeid',
                        loadChildren: () =>
                            import('./m-detail/m-detail.module').then(m => m.MDetailModule)
                    },
                    {
                        path: 'album',
                        loadChildren: () =>
                            import('./m-album/m-album.module').then(m => m.MAlbumModule)
                    },
                    {
                        path: 'image/:id',
                        loadChildren: () =>
                            import('./m-image/m-image.module').then(m => m.MImageModule)
                    },
                    {
                        path: 'feedback',
                        loadChildren: () =>
                            import('./m-feedback/m-feedback.module').then(m => m.MFeedbackModule)
                    },
                    {
                        path: 'login',
                        loadChildren: () =>
                            import('./m-login/m-login.module').then(m => m.MLoginModule)
                    },
                    {
                        path: 'map-contact',
                        loadChildren: () =>
                            import('./m-map-contact/m-map-contact.module').then(m => m.MMapContactModule)
                    },
                    {
                        path: 'sitemap',
                        loadChildren: () =>
                            import('./m-sitemap/m-sitemap.module').then(m => m.MSiteMapModule)
                    },
                    {
                        path: 'schedule',
                        loadChildren: () =>
                            import('./m-schedule/m-schedule.module').then(m => m.MScheduleModule)
                    },
                    {
                        path: 'search',
                        loadChildren: () =>
                            import('./m-search/m-search.module').then(m => m.MSearchModule)
                    },
                    {
                        path: 'search/:titleSearch',
                        loadChildren: () =>
                            import('./m-search/m-search.module').then(m => m.MSearchModule)
                    },
                    {
                        path: 'about',
                        loadChildren: () =>
                            import('./m-about/m-about.module').then(m => m.MAboutModule)
                    },
                    {
                        path: 'examination',
                        loadChildren: () =>
                            import('./m-examination/m-examination.module').then(m => m.MExaminationModule),
                        // canActivate: [AuthGuard],
                    },
                    {
                        path: 'surveyresults',
                        loadChildren: () =>
                            import('./survey-results/survey-results.module').then(m => m.SurveyResultsModule)
                    }
                ]
            }
        ]),
    ],
    providers: [ApiService],
    entryComponents: []
})
export class ContentModule { }
